import {FC} from 'react';

import LightTwoColsHeader from '~src/shared/headers/lightTwoColsHeader/LightTwoColsHeader';

import SurveyOverviewSection from './surveyOverviewSection/surveyOverviewSection';
import { UserHomeBackground } from './userHome.sc';

const UserHome: FC = () => (<>
  <LightTwoColsHeader
    title={{ key: 'x.user.home.header.title' }}
    descr={{ key: 'x.user.home.header.description' }}
  />
  <UserHomeBackground>
    <SurveyOverviewSection />
  </UserHomeBackground>
</>);

export default UserHome;
